<div class="container">
  <div class="row">
    <div class="col-lg-3 col--flex">
      <port-shortcut-menu [subscription]="subscription()" [activities]="activities()" />
    </div>

    <div class="col-lg-9">
      <div class="card">
        <subscription-detail-header
          [subscription]="subscription()"
          [titleKey]="'PortDetails'"
          [showReportIncidentButton]="isCurrentOrganisation()"
        />

        <div class="row">
          <div class="col-12 col-sm-7">
            <table class="table-properties table-properties--no-margin">
              <tr>
                <td>{{ "ServiceElement.Owner" | translate }}</td>
                <td>{{ owner() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.OwnAlias" | translate }}</td>
                <td>
                  <alias-editor [customerDescription]="customerDescription()" [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.SURFnetDescription" | translate }}</td>
                <td>{{ description() }}</td>
              </tr>
              @if (hasReferences()) {
                <tr third-party-service-ids-row-content [references]="references()"></tr>
              }
              <tr>
                <td>{{ "ServiceElement.PortID" | translate }}</td>
                <td><service-id [subscriptionId]="subscriptionId()" /></td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.PortSpeed" | translate }}</td>
                <td>{{ portSpeed() | service_speed }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.PortMode" | translate }}</td>
                <td>{{ portMode() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.L2MTU" | translate }}</td>
                <td>9100</td>
              </tr>
            </table>
          </div>
          <div class="col-12 col-sm-5">
            <table class="table-properties table-properties--no-margin">
              @if (!isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.City" | translate }}</td>
                  <td>
                    @if (address()) {
                      <span>{{ address()!.city }} ({{ subscription().surfLocationCode }})</span>
                    }
                  </td>
                </tr>
                <tr>
                  <td>{{ "ServiceElement.Address" | translate }}</td>
                  @if (address()) {
                    <td>
                      <span> {{ address()!.street }} {{ address()!.number }} {{ address()!.city }} </span>
                    </td>
                  }
                </tr>
              }
              @if (!isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.InterfaceType" | translate }}</td>
                  <td>{{ "ServiceElement.InterfaceType.Aggregate" | translate }}</td>
                </tr>
              }
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.Status" | translate }}</td>
                  <td>{{ status() }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Start" | translate }}</td>
                <td>{{ startDate() | subscription_date }}</td>
              </tr>
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.End" | translate }}</td>
                  <td>{{ endDate() | subscription_date }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Domain" | translate }}</td>
                <td>{{ domain() }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (isTerminated()) {
    <div class="hide-everything-after-this-div"></div>
  }
  <div class="divider">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div>
    <div class="section">
      <port-services-panel [subscription]="subscription()"></port-services-panel>
    </div>
    <link-member-subscriptions [linkMemberSubscriptions]="linkMemberSubscriptions()" />
  </div>
  <traffic-line-chart [subjects]="chartSubjects()" />
</div>
